import DayJsAdapter from '@date-io/dayjs'
import '@fortawesome/fontawesome-pro/css/all.css'
import { de as dateDe } from 'date-fns/locale'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { getIconsFlattened } from 'plugins/i18n/icons.ts'
import { createVuetify } from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { md } from 'vuetify/iconsets/md'
import { VIconBtn } from 'vuetify/labs/VIconBtn'
import { de, en } from 'vuetify/locale'
import { fontawesomeAliases } from './aliases'
import { hausperfektTheme } from './themes'

// Add the UTC plugin to dayjs
dayjs.extend(utc)

const createVuetifyWithOptions = () => {
	return createVuetify({
		components: {
			VIconBtn,
		},
		defaults: {
			VTextField: {
				variant: 'underlined',
			},
			VCombobox: {
				variant: 'underlined',
			},
			VAutocomplete: {
				variant: 'underlined',
				color: 'primary',
			},
			VSelect: {
				variant: 'underlined',
			},
			VIcon: {
				size: 'small',
			},
			VCard: {
				VCard: {
					class: ['bg-surface-lighten-1'],
					VCard: {
						class: ['bg-surface-lighten-2'],
					},
				},
			},
		},
		icons: {
			defaultSet: 'fa',
			aliases: {
				...aliases,
				...fontawesomeAliases,
				...getIconsFlattened(),
			},
			sets: {
				md,
				fa,
			},
		},
		locale: {
			locale: 'de',
			fallback: 'en',
			messages: { de, en },
		},
		date: {
			adapter: DayJsAdapter,
			locale: {
				de: dateDe,
			},
		},
		theme: {
			defaultTheme: 'client',
			variations: {
				colors: [
					'nav',
					'table',
					'background',
					'surface',
					'error',
					'success',
					'info',
				],
				lighten: 2,
				darken: 2,
			},
			themes: {
				client: {
					...hausperfektTheme,
				},
				dark: {
					dark: true,
					colors: {
						nav: '#121212',
						text: '#ff1493', // TODO: TEST FARBE IF SEEN ACT!!
						//table: '#0b0b0b',
						table: '#121212',
					},
				},
				light: {
					dark: false,
					colors: {
						nav: '#ffffff',
						text: '#ff1493', // TODO: TEST FARBE IF SEEN ACT!!
						//	table: '#f0f0f0',
						table: '#ffffff',
					},
				},
			},
		},
	})
}

export async function createVuetifyInstance() {
	return createVuetifyWithOptions()
}
